export interface Feedback {
  id?: number;
  uuid?: string;
  filemakerUUID?: string;
  ticketId?: number;
  createdBy?: string;
  createdAt?: string;
  feedback: string;
}

export interface Ticket {
  id?: number;
  uuid?: string;
  ticketId: string;
  facilityName?: string;
  facilityGroupName?: string;
  filemakerUUID?: string;
  status?: string;
  priority?: string;
  radiologist?: string;
  category?: string;
  subCategory?: string;
  contact?: string;
  supportArea?: string;
  createdBy?: string;
  createdAt?: string;
  subject?: string;
  description?: string;
  previousId?: number;
  nextId?: number;
  feedbackItems?: Feedback[];
  attachmentItems?: any[];
}

export const getFeedbackInitialValue =
  (): Feedback => {
    return {
      id: undefined,
      uuid: '',
      filemakerUUID: '',
      ticketId: undefined,
      createdBy: '',
      createdAt: '',
      feedback: '',
    };
  };

export const getTicketInitialValue =
  (): Ticket => {
    return {
      id: 0,
      uuid: '',
      ticketId: '',
      facilityName: '',
      facilityGroupName: '',
      filemakerUUID: '',
      status: '',
      priority: '',
      radiologist: '',
      category: '',
      subCategory: '',
      contact: '',
      supportArea: '',
      createdBy: '',
      subject: '',
      description: '',
      previousId: 0,
      nextId: 0,
      feedbackItems: [],
    };
  };

export interface TicketsFile {
  ticketId?: number;
  file?: string;
}

export const TicketsData: Ticket[] = [
  {
    id: 1,
    uuid: "b8f5e1a2-9d3b-4d6e-bfdc-1e2345678901",
    ticketId: "TCK-001",
    facilityName: "City Hospital",
    facilityGroupName: "Medical Group A",
    status: "Open",
    priority: "High",
    radiologist: "Dr. John Smith",
    category: "Radiology",
    subCategory: "MRI",
    contact: "jane.doe@example.com",
    supportArea: "Imaging",
    createdBy: "admin",
    createdAt: "2023-09-15T10:30:00",
    subject: "MRI Scanner not working",
  },
  {
    id: 2,
    uuid: "c2a5e7d9-1a8d-4f3c-bfdc-2b3456789012",
    ticketId: "TCK-002",
    facilityName: "General Clinic",
    facilityGroupName: "Medical Group B",
    status: "In Progress",
    priority: "Medium",
    radiologist: "Dr. Alice Brown",
    category: "X-Ray",
    subCategory: "Chest",
    contact: "mark.jones@example.com",
    supportArea: "Radiology",
    createdBy: "jdoe",
    createdAt: "2023-09-16T14:45:00",
    subject: "X-ray image upload issue",
  },
  {
    id: 3,
    uuid: "d9f2e3b1-7b9c-4a2e-bfdc-3c4567890123",
    ticketId: "TCK-003",
    facilityName: "Westside Health",
    facilityGroupName: "Medical Group A",
    status: "Closed",
    priority: "Low",
    radiologist: "Dr. Michael Johnson",
    category: "Ultrasound",
    subCategory: "Abdomen",
    contact: "susan.lee@example.com",
    supportArea: "Ultrasound",
    createdBy: "mjohnson",
    createdAt: "2023-09-18T09:15:00",
    subject: "Ultrasound image quality issue Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus imperdiet, nulla et dictum interdum, nisi lorem egestas odio, vitae scelerisque enim ligula venenatis dolor. Maecenas nisl est, ultrices nec congue eget, auctor vitae massa. Fusce luctus vestibulum augue ut aliquet. Mauris ante ligula, facilisis sed ornare eu, lobortis in odio. Praesent convallis urna a lacus interdum ut hendrerit risus congue. Nunc sagittis dictum nisi, sed ullamcorper ipsum dignissim ac. In at libero sed nunc venenatis imperdiet sed ornare turpis. Donec vitae dui eget tellus gravida venenatis. Integer fringilla congue eros non fermentum. Sed dapibus pulvinar nibh tempor porta. ",
  }
];

export const FeedbackData: Feedback[] = [
  {
    id: 1,
    feedback: "Excellent support. The response was quick and helpful. Thank you!",
    createdBy: "admin",
    createdAt: "2023-09-15T11:00:00",
    uuid: "",
    filemakerUUID: "",
    ticketId: 0
  },
  {
    id: 2,
    feedback:
      "I had trouble accessing the MRI images, but the team resolved it swiftly.",
    createdBy: "jdoe",
    createdAt: "2023-09-16T15:30:00",
  },
  {
    id: 3,
    feedback:
      "Support was slow. I waited over an hour for assistance. Please improve.",
    createdBy: "susan.lee",
    createdAt: "2023-09-18T10:00:00",
  },
];
